import { Component } from '@angular/core';
import { ParkourInfoCardWithTitleComponent } from '@parkour/ui';
import { RouterLink } from '@angular/router';
import { from } from 'rxjs';
import { Device } from '@capacitor/device';
import { AsyncPipe } from '@angular/common';
import { isNativeApp } from '../../../utils';

@Component({
  selector: 'parkour-web-app-warning-card',
  standalone: true,
  imports: [ParkourInfoCardWithTitleComponent, RouterLink, AsyncPipe],
  templateUrl: './web-app-warning-card.component.html',
})
export class WebAppWarningCardComponent {
  protected readonly deviceInfo$ = from(Device.getInfo());
  protected readonly isNativeApp = isNativeApp;
}
